import { useState } from 'react'

interface Service {
    type: string
    value: number
}

export const useServiceTax = () => {
    const [hasService, setHasService] = useState(false)
    const [serviceSeparated, setServiceSeparated] = useState<'no' | 'yes'>('no')
    const [services, setServices] = useState<Service[]>([{ type: '-1', value: 0 }])

    const addService = () => {
        if (services.length < 6) {
            setServices([...services, { type: '-1', value: 0 }])
        }
    }

    const removeService = (index: number) => {
        if (services.length > 1) {
            setServices(services.filter((_, i) => i !== index))
        }
    }

    const updateServiceType = (index: number, type: string) => {
        const newServices = [...services]
        newServices[index].type = type
        setServices(newServices)
    }

    const updateServiceValue = (index: number, value: number) => {
        const newServices = [...services]
        newServices[index].value = value
        setServices(newServices)
    }

    return {
        hasService,
        setHasService,
        serviceSeparated,
        setServiceSeparated,
        services,
        addService,
        removeService,
        updateServiceType,
        updateServiceValue,
    }
}
